import type { TIconName } from '@pu/mpp-ui/components/icon';
import { ENavItemType } from 'core/model/enums/nav-item.enum';
import type { IModuleNavigationDetail } from 'core/model/interfaces/module-navigation.interface';
import type { INavItem } from 'shared/components/side-nav/components';

export const transformModuleNavigationToNavItems = (moduleNavigation: IModuleNavigationDetail): INavItem => ({
  type: ENavItemType.LINK,
  link: {
    label: moduleNavigation.name,
    icon: moduleNavigation.iconName as TIconName,
    to: moduleNavigation.uri,
  },
});
